import { Breadcrumb, Card, Divider } from "antd"
import {Link} from "react-router-dom"
import { DashboardOutlined } from "@ant-design/icons"
import {FaMoneyBillWave,FaMoneyBill} from "react-icons/fa";
import {TbArrowsRightLeft} from "react-icons/tb";
import { GrPaypal } from "react-icons/gr";
import {AiOutlineSetting,AiOutlineEnter} from "react-icons/ai";
import {BiNotepad,BiSupport} from "react-icons/bi";
import {BsBuilding} from "react-icons/bs";
import {MdOutlineLibraryBooks,MdPeople} from "react-icons/md";
import Header from "./header";
import {ADMIN} from "../../helpers/roles";
import {userStore} from "../../store/userStore";



const LINKS = [
    {
        title:"Manage Users",
        icon:<MdPeople style={{
            fontSize:"3em",
            // color:"white"
        }}/>,
        link:"/dashboard/users",
        roles: [ADMIN]
    },
    {
        title:"Users Payroll",
        icon:<GrPaypal style={{
            fontSize:"3em",
            // color:"white"
        }}/>,
        link:"/dashboard/payroll",
        roles: []
    },
    {
        title:"Budgets",
        icon:<MdOutlineLibraryBooks style={{
            fontSize:"3em",
            // color:"white"
        }}/>,
        link:"/dashboard/budgets",
        roles: []
    },
    {
        title:"Settings",
        icon:<AiOutlineSetting style={{
            fontSize:"3em",
            // color:"white"
        }}/>,
        link:"/dashboard/voucher-config",
        roles: [ADMIN]
    },
    {
        title:"Manage Memos",
        icon:<BiNotepad style={{
            fontSize:"3em",
            // color:"white"
        }}/>,
        link:"/dashboard/memo/manage/memo",
        roles: []
    },
    {
        title:"Offices",
        icon:<BsBuilding style={{
            fontSize:"3em",
        }}/>,
        link:"/dashboard/units",
        roles: [ADMIN]
    },
    {
        title:"Report",
        icon:<BiSupport style={{
            fontSize:"3em",
            // color:"white"
        }}/>,
        link:"/dashboard",
        roles: []
    },
    {
        title:"Payment Voucher",
        icon:<FaMoneyBill style={{
            fontSize:"3em",
            // color:"white"
        }}/>,
        link:"/dashboard/voucher",
        roles: []
    }
]

export default function Content(){
    const user = userStore(state => state.user);
    const deepContain = (link) => {
        return (user?.roles ?? []).filter(e => link.roles.length === 0 || link.roles.includes(e)).length > 0
    }

    return(
        <>
            <div className="main-container">
                <Header/>
                <div className="main-body">

                    <div className="info-bar">
                    <Breadcrumb>
                        <Breadcrumb.Item>
                        <DashboardOutlined className="dashboard-icon"/>
                        <Link to={"/dashboard"}>Dashboard</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>{" "}</Breadcrumb.Item>
                    </Breadcrumb>
                        <div>

                        </div>
                    </div>
                    <div className="dashboard-stats">
                        <div className="stat-card budget-card">
                            <Link to="/dashboard/budgets" className="stat-link">
                                <div className="stat-icon">
                                    <MdOutlineLibraryBooks />
                                </div>
                                <div className="stat-content">
                                    <h3>Budget Management</h3>
                                    <p>Track and manage financial budgets</p>
                                    <div className="stat-number">12 Active</div>
                                </div>
                            </Link>
                        </div>
                        <div className="stat-card voucher-card">
                            <Link to="/dashboard/voucher" className="stat-link">
                                <div className="stat-icon">
                                    <FaMoneyBillWave />
                                </div>
                                <div className="stat-content">
                                    <h3>Payment Vouchers</h3>
                                    <p>Process and track payments</p>
                                    <div className="stat-number">24 Pending</div>
                                </div>
                            </Link>
                        </div>
                        <div className="stat-card memo-card">
                            <Link to="/dashboard/memo/manage/memo" className="stat-link">
                                <div className="stat-icon">
                                    <TbArrowsRightLeft />
                                </div>
                                <div className="stat-content">
                                    <h3>Memo System</h3>
                                    <p>Document workflows and approvals</p>
                                    <div className="stat-number">8 New</div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="navigation-section">
                        <div className="section-header">
                            <h2>Quick Navigation</h2>
                            <AiOutlineEnter className="section-icon" />
                        </div>
                        <div className="navigation-grid">
                            {LINKS.filter(e => deepContain(e)).map((item, idx) => (
                                <Link key={idx} to={item.link} className="nav-card">
                                    <div className="nav-card-icon">
                                        {item.icon}
                                    </div>
                                    <h3 className="nav-card-title">
                                        {item.title}
                                    </h3>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
